export const WHISPER_SAMPLING_RATE = 16_000;
export const MAX_AUDIO_LENGTH = 30;
export const MAX_SAMPLES = WHISPER_SAMPLING_RATE * MAX_AUDIO_LENGTH;
export const IS_WEBGPU_AVAILABLE = typeof window !== 'undefined' 
  && 'gpu' in window.navigator 
  && window.navigator.gpu !== null 
  && window.navigator.gpu !== undefined;

export const isBlob = (obj: any): obj is Blob => obj instanceof Blob;
export const isValidBlob = (obj: any): boolean => isBlob(obj) && obj.size > 0;
export const getTotalVideoDuration=async(videoUrls: string[]): Promise<number> => {
    return new Promise((resolve) => {
        let totalDuration = 0;
        let loadedCount = 0;
        videoUrls.forEach((url) => {
            const video = document.createElement('video');
            video.src = url;
            
            video.addEventListener('loadedmetadata', () => {
                totalDuration += video.duration;
                loadedCount++;
                
                
                if (loadedCount === videoUrls.length) {
                    resolve(totalDuration);
                }
            });
        });
    });
}
export const getTotalVideoDurationSigngle=async(videoUrl: string): Promise<number> => {
  return new Promise((resolve) => {
      let totalDuration = 0;
      let loadedCount = 0;
      const video = document.createElement('video');
          video.src = videoUrl;
          
          video.addEventListener('loadedmetadata', () => {
              totalDuration += video.duration;
              loadedCount++;
              resolve(totalDuration);
              
          });
  });
}

export const getVideoBlobDuration = (videoBlob: Blob): Promise<number> => {
 return new Promise((resolve, reject) => {
   const videoUrl = URL.createObjectURL(videoBlob);
   
   const video = document.createElement('video');
   
   video.addEventListener('loadedmetadata', () => {
     URL.revokeObjectURL(videoUrl);
     
     resolve(video.duration);
   });
   
   video.addEventListener('error', (error) => {
     URL.revokeObjectURL(videoUrl);
     
     reject(error);
   });
   
   video.src = videoUrl;
   video.preload = 'metadata';
 });
}

export const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    
    if(hours > 0){
        return [
            String(hours).padStart(2, '0'),
            String(minutes).padStart(2, '0'),
            String(remainingSeconds).padStart(2, '0')
        ].join(':'); 
    }
    return [
        String(minutes).padStart(2, '0'),
        String(remainingSeconds).padStart(2, '0')
    ].join(':');
};

export const shuffleArray = (array: any[]) => {
    let shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};


export const generateVideoThumbnail = (videoFile: Blob, timeInSeconds: number = 1, quality: number = 0.7) => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.playsInline = true;
    video.muted = true;
    
    
    const url = URL.createObjectURL(videoFile);
    
    
    video.onloadedmetadata = () => {
      video.currentTime = Math.min(timeInSeconds, video.duration);
    };
    
    video.onseeked = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
    
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      
     
      const thumbnailDataUrl = canvas.toDataURL('image/jpeg', quality);
      
    
      URL.revokeObjectURL(url);
      
      resolve(thumbnailDataUrl);
    };
    
    video.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Error loading video'));
    };
    
    // Set video source and load
    video.src = url;
    video.load();
  });
};

